/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ModalEl} from 'common/components/modal';
import {CreateProjectFieldEl} from 'common/widgets/create-project-field';

import type {CreateProjectModal} from './index';

export function template(this: CreateProjectModal) {
  return (
    <ModalEl
      sel='.project-creation'
      attrs={{
        open: this.attr(`open`),
      }}
    >
      <div sel='.mp-modal-content'>
        <div sel='.mp-modal-title'>{this.getContext(`i18n`).t(`settings.project-settings.create.title`)}</div>
        <CreateProjectFieldEl
          attrs={{
            'organization-id': this.attr(`organization-id`),
            orgs: this.attr(`orgs`),
            'is-setup': this.attr(`is-setup`),
            'project-id': this.attr(`project-id`),
          }}
          on={{
            cancel: () => this.dispatchEvent(new CustomEvent(`cancel`)),
            create: (evt) => this.dispatchEvent(new CustomEvent(`create`, {detail: evt.detail})),
          }}
        />
      </div>
    </ModalEl>
  );
}
